import { useEffect, useState } from "react";

import { useApiClient } from "../../api-client";
import { useEmployment } from "../home/useEmployment";

const restorePayrollCycle = ({
  id,
  payrollMonth,
  fiscalYear,
  startTimestamp,
}: any) => {
  return {
    id,
    payrollMonth,
    fiscalYear,
    startTimestamp,
  };
};

export type PayrollCycle = {
  id: string;
  payrollMonth: string;
  fiscalYear: string;
  startTimestamp: number;
};

const usePayrollCycles = () => {
  const { get } = useApiClient();
  const [payrollCycles, setPayrollCycles] = useState<PayrollCycle[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { employmentId } = useEmployment();

  const getPayrollCycles = async () => {
    const { data } = await get(
      `/v1/employee/${employmentId}/company/payroll-cycles`
    );

    const cycles = data.content.map(restorePayrollCycle);

    cycles.sort(
      (a: PayrollCycle, b: PayrollCycle) => a.startTimestamp - b.startTimestamp
    );

    setPayrollCycles(cycles);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!employmentId) return;
    getPayrollCycles();
  }, [employmentId]);

  return { isLoading, payrollCycles };
};

export { usePayrollCycles };
